import type { ILineProps } from '../Transition';
import { getColorCode, getCoordinates } from '../helpers';
import { marker } from '../Markers';
import { TransitionLabel } from './TransitionLabel';

export function Loop(props: ILineProps) {
    const { label, strokeWidth, color, fromStep, graphSizes } = props;

    const nodeCoordinates = getCoordinates(fromStep.displayOptions, graphSizes);
    const startCoordinates = {
        x: nodeCoordinates.x + graphSizes.nodeWidth,
        y: nodeCoordinates.y + graphSizes.nodeHeight * 0.5,
    };
    const endCoordinates = {
        x: nodeCoordinates.x + graphSizes.nodeWidth - graphSizes.nodeHeight * 0.5,
        y: nodeCoordinates.y + graphSizes.nodeHeight,
    };
    const radius = graphSizes.nodeHeight * 0.5;

    return (
        <>
            <path
                d={`M ${startCoordinates.x} ${startCoordinates.y} A ${radius} ${radius} 0 1 1 ${endCoordinates.x} ${endCoordinates.y}`}
                fill="none"
                markerEnd={marker(color)}
                stroke={getColorCode(color)}
                strokeWidth={strokeWidth}
            />
            {label && (
                <TransitionLabel
                    center={{
                        x: startCoordinates.x + graphSizes.nodeHeight * 0.3,
                        y: startCoordinates.y + graphSizes.nodeHeight * 0.6,
                    }}
                    graphSizes={graphSizes}
                    label={label}
                />
            )}
        </>
    );
}
